import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeCreateNewPassword, CreateNewPassword } from '../../lib/apiService'
import useLogger from '../../lib/logger/use-logger'
import useNotifications from '../../lib/notifications/use-notifications'
import CreateNewPasswordForm, {
  OnChangeEmail,
  OnCreateNewPasswordSuccess,
  OnCreatePasswordFailure,
} from '../../components/forms/create-new-password'
import OnboardingPage from '../onboarding-page'
import { VERIFY_CODE } from '../paths'

interface Props {
  setEmail(email: string): void
  draftEmail: string
  setDraftEmail(email: string): void
  setActionName(actionName: string): void
}

const CreatePasswordPage: React.FC<Props> = (props) => {
  const history = useHistory()
  const logger = useLogger()
  const { setNotification, clearNotifications } = useNotifications()

  const onChangeEmail: OnChangeEmail = (email) => {
    props.setDraftEmail(email)
  }

  const onCreateNewPasswordSuccess: OnCreateNewPasswordSuccess = (data) => {
    props.setEmail(data.email)
    props.setActionName('create-password')
    history.push(VERIFY_CODE)
  }

  const onCreateNewPasswordFailure: OnCreatePasswordFailure = () => {
    setNotification({
      id: 'create-password-page/on-failure',
      type: 'failure',
      message:
        'There was a problem, please re-enter your email address and try again.',
    })
  }

  const createNewPassword: CreateNewPassword = makeCreateNewPassword({
    logger,
  })

  return (
    <OnboardingPage>
      <CreateNewPasswordForm
        draftEmail={props.draftEmail}
        onChangeEmail={onChangeEmail}
        onCreateNewPasswordSuccess={onCreateNewPasswordSuccess}
        onCreateNewPasswordFailure={onCreateNewPasswordFailure}
        createNewPassword={(...args) => {
          clearNotifications()
          return createNewPassword(...args)
        }}
      />
    </OnboardingPage>
  )
}

export default CreatePasswordPage
